import { apiService } from "core/services/apiService";
import { safeSetItem } from "core/utils/localStorageUtils";


export interface Lineup {
    type: string;
    lineupId: string;
    name: string;
    device?: string;
    location?: string;
    mso?: {
        id: string;
        name: string;
    };
}



// localStorage key for caching
const LINEUPS_STORAGE_KEY = 'gracenote_lineups_cache';

// Function to clear lineups cache
export const clearLineupsCache = (workplaceId?: number) => {
    if (workplaceId) {
        localStorage.removeItem(`${LINEUPS_STORAGE_KEY}_${workplaceId}`);
    } else {
        // Clear all lineups cache entries
        Object.keys(localStorage).forEach(key => {
            if (key.startsWith(LINEUPS_STORAGE_KEY)) {
                localStorage.removeItem(key);
            }
        });
    }
};

export const fetchGracenoteLineups = async (
    workplaceId: number,
    useCache: boolean = true
): Promise<Lineup[]> => {
    // Check localStorage first
    if (useCache) {
        const cachedData = localStorage.getItem(`${LINEUPS_STORAGE_KEY}_${workplaceId}`);
        if (cachedData) {
            try {
                const parsedData = JSON.parse(cachedData);
                if (parsedData && parsedData.lineups && parsedData.lineups.length > 0) {
                    return parsedData.lineups;
                }
            } catch (error) {
                console.warn("Error parsing cached lineups:", error);
            }
        }
    }

    // Fetch from API if not cached
    const response = await apiService.get<Lineup[]>(
        `/workplaces/gracenote/lineups`,
        { params: { page: 1, itemsPerPage: 500, workplaceID: workplaceId } }
    );

    // add static values of "DIRECTV ESPN+ Business"
    const STATIC_VALUE_FOR_LINEUP = {
        type: "STREAMING",
        device: "X",
        lineupId: "USA-ESPNPLUS-DTV",
        name: "DIRECTV ESPN+ Business",
        location: "Nationwide",
        mso: {
            id: "17581",
            name: "DIRECTV",
        },
    };

    const lineups = [...response.data, STATIC_VALUE_FOR_LINEUP];
    
    // Store in localStorage with quota handling
    const cacheData = JSON.stringify({
        lineups,
        timestamp: Date.now()
    });
    
    if (!safeSetItem(`${LINEUPS_STORAGE_KEY}_${workplaceId}`, cacheData)) {
        console.warn('Failed to cache lineups due to quota exceeded');
    }

    return lineups;
};
